export default __webpack_public_path__ + "static/media/print-3-labels-first-position.decc339c.svg";